// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-form .el-table .cell .el-form-item__content[data-v-bdf9f29c] {\n  line-height: normal;\n}\n.el-form-item[data-v-bdf9f29c] {\n  margin-bottom: 10px;\n}", ""]);
// Exports
module.exports = exports;
